import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ConditionalIntroductionMessageQueryVariables = Types.Exact<{
  input: Types.Scalars['ID']['input'];
}>;


export type ConditionalIntroductionMessageQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', hasLineActivationProvider: boolean }, conditionalIntroductionMessage: { __typename?: 'ConditionalIntroductionMessage', guid: string, content: { __typename: 'PlainIntroductionMessageContent', body: string, selections: Array<string> } | { __typename: 'ScenarioChatIntroductionMessageContent', scenarioChatGuid: string }, condition: { __typename?: 'IntroductionMessageCondition', userRegistrationInflowSourceDefinition: { __typename?: 'UserRegistrationInflowSourceDefinition', guid: string, inflowSourceName: string } } } };

export type UpdateConditionalIntroductionMessageMutationVariables = Types.Exact<{
  input: Types.UpdateConditionalIntroductionMessageInput;
}>;


export type UpdateConditionalIntroductionMessageMutation = { __typename?: 'Mutation', updateConditionalIntroductionMessage: { __typename: 'AlreadyExistsConditionalIntroductionMessageError' } | { __typename: 'SaveIntroductionMessageSuccess', setting: { __typename?: 'IntroductionMessageSetting', default?: { __typename?: 'DefaultIntroductionMessage', content: { __typename: 'PlainIntroductionMessageContent', body: string, selections: Array<string> } | { __typename: 'ScenarioChatIntroductionMessageContent', scenarioChatGuid: string } } | null } } };

export type RemoveConditionalIntroductionMessageMutationVariables = Types.Exact<{
  input: Types.RemoveConditionalIntroductionMessageInput;
}>;


export type RemoveConditionalIntroductionMessageMutation = { __typename?: 'Mutation', removeConditionalIntroductionMessage: { __typename?: 'SaveIntroductionMessageSuccess', setting: { __typename?: 'IntroductionMessageSetting', default?: { __typename?: 'DefaultIntroductionMessage', content: { __typename: 'PlainIntroductionMessageContent', body: string, selections: Array<string> } | { __typename: 'ScenarioChatIntroductionMessageContent', scenarioChatGuid: string } } | null } } };


export const ConditionalIntroductionMessageDocument = gql`
    query conditionalIntroductionMessage($input: ID!) {
  viewer {
    hasLineActivationProvider
  }
  conditionalIntroductionMessage(guid: $input) {
    guid
    content {
      __typename
      ... on PlainIntroductionMessageContent {
        body
        selections
      }
      ... on ScenarioChatIntroductionMessageContent {
        scenarioChatGuid
      }
    }
    condition {
      userRegistrationInflowSourceDefinition {
        guid
        inflowSourceName
      }
    }
  }
}
    `;

/**
 * __useConditionalIntroductionMessageQuery__
 *
 * To run a query within a Vue component, call `useConditionalIntroductionMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useConditionalIntroductionMessageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useConditionalIntroductionMessageQuery({
 *   input: // value for 'input'
 * });
 */
export function useConditionalIntroductionMessageQuery(variables: ConditionalIntroductionMessageQueryVariables | VueCompositionApi.Ref<ConditionalIntroductionMessageQueryVariables> | ReactiveFunction<ConditionalIntroductionMessageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ConditionalIntroductionMessageQuery, ConditionalIntroductionMessageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConditionalIntroductionMessageQuery, ConditionalIntroductionMessageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConditionalIntroductionMessageQuery, ConditionalIntroductionMessageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ConditionalIntroductionMessageQuery, ConditionalIntroductionMessageQueryVariables>(ConditionalIntroductionMessageDocument, variables, options);
}
export function useConditionalIntroductionMessageLazyQuery(variables?: ConditionalIntroductionMessageQueryVariables | VueCompositionApi.Ref<ConditionalIntroductionMessageQueryVariables> | ReactiveFunction<ConditionalIntroductionMessageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ConditionalIntroductionMessageQuery, ConditionalIntroductionMessageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConditionalIntroductionMessageQuery, ConditionalIntroductionMessageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConditionalIntroductionMessageQuery, ConditionalIntroductionMessageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ConditionalIntroductionMessageQuery, ConditionalIntroductionMessageQueryVariables>(ConditionalIntroductionMessageDocument, variables, options);
}
export type ConditionalIntroductionMessageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ConditionalIntroductionMessageQuery, ConditionalIntroductionMessageQueryVariables>;
export const UpdateConditionalIntroductionMessageDocument = gql`
    mutation updateConditionalIntroductionMessage($input: UpdateConditionalIntroductionMessageInput!) {
  updateConditionalIntroductionMessage(input: $input) {
    __typename
    ... on SaveIntroductionMessageSuccess {
      setting {
        default {
          content {
            __typename
            ... on PlainIntroductionMessageContent {
              body
              selections
            }
            ... on ScenarioChatIntroductionMessageContent {
              scenarioChatGuid
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUpdateConditionalIntroductionMessageMutation__
 *
 * To run a mutation, you first call `useUpdateConditionalIntroductionMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConditionalIntroductionMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateConditionalIntroductionMessageMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConditionalIntroductionMessageMutation(options: VueApolloComposable.UseMutationOptions<UpdateConditionalIntroductionMessageMutation, UpdateConditionalIntroductionMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateConditionalIntroductionMessageMutation, UpdateConditionalIntroductionMessageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateConditionalIntroductionMessageMutation, UpdateConditionalIntroductionMessageMutationVariables>(UpdateConditionalIntroductionMessageDocument, options);
}
export type UpdateConditionalIntroductionMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateConditionalIntroductionMessageMutation, UpdateConditionalIntroductionMessageMutationVariables>;
export const RemoveConditionalIntroductionMessageDocument = gql`
    mutation removeConditionalIntroductionMessage($input: RemoveConditionalIntroductionMessageInput!) {
  removeConditionalIntroductionMessage(input: $input) {
    ... on SaveIntroductionMessageSuccess {
      setting {
        default {
          content {
            __typename
            ... on PlainIntroductionMessageContent {
              body
              selections
            }
            ... on ScenarioChatIntroductionMessageContent {
              scenarioChatGuid
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRemoveConditionalIntroductionMessageMutation__
 *
 * To run a mutation, you first call `useRemoveConditionalIntroductionMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConditionalIntroductionMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveConditionalIntroductionMessageMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRemoveConditionalIntroductionMessageMutation(options: VueApolloComposable.UseMutationOptions<RemoveConditionalIntroductionMessageMutation, RemoveConditionalIntroductionMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveConditionalIntroductionMessageMutation, RemoveConditionalIntroductionMessageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveConditionalIntroductionMessageMutation, RemoveConditionalIntroductionMessageMutationVariables>(RemoveConditionalIntroductionMessageDocument, options);
}
export type RemoveConditionalIntroductionMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveConditionalIntroductionMessageMutation, RemoveConditionalIntroductionMessageMutationVariables>;